import { useParams } from "react-router-dom"
import useUserPermissions from "hooks/UseUserPermissions"
import { ConfigGroupOrderType } from "types/OrderType"
import { EShippinggroupAction, EShippinggroupStatus } from "enums/shippinggroupEmun"
import { ResourcePermissionsEnum } from "enums/ResourcePermissionsEnum"
import { useTranslation } from "react-i18next"

const useConditionalsGroupOrder = () => {
  const { type, shippingtype } = useParams<{ type: string, shippingtype: string }>()

  const { t } = useTranslation()

  const configGroupOrder: Array<ConfigGroupOrderType> = [
    {
      status: EShippinggroupStatus.package,
      action: EShippinggroupAction.packed,
      labelAction: t("LABEL_PACKED_GROUP"),
      permission: ResourcePermissionsEnum.shippingGroup,
      shippingType: "sp_hd"
    },
    {
      status: EShippinggroupStatus.delivery,
      action: EShippinggroupAction.shipped,
      permission: ResourcePermissionsEnum.shippingGroup,
      labelAction: t("LABEL_SHIPPED_GROUP"),
      shippingType: "sp_hd"
    },
    {
      status: EShippinggroupStatus.transit,
      action: EShippinggroupAction.delivered,
      permission: ResourcePermissionsEnum.shippingGroup,
      labelAction: t("LABEL_DELIVERED_GROUP"),
      shippingType: "sp_hd"
    },
    {
      status: EShippinggroupStatus.pickup,
      action: EShippinggroupAction.picked_up,
      permission: ResourcePermissionsEnum.shippingGroup,
      labelAction: t("LABEL_PICKED_UP_GROUP"),
      shippingType: "sp_hd"
    },
    {
      status: EShippinggroupStatus.delivery,
      action: EShippinggroupAction.shipped,
      permission: ResourcePermissionsEnum.shippingGroup,
      labelAction: t("LABEL_SHIPPED_GROUP"),
      shippingType: "rt"
    },
    {
      status: EShippinggroupStatus.transit,
      action: EShippinggroupAction.delivered,
      permission: ResourcePermissionsEnum.shippingGroup,
      labelAction: t("LABEL_DELIVERED_GROUP"),
      shippingType: "rt"
    },
  ]

  const statusGroup = configGroupOrder?.find(({ status, shippingType }: any) => 
    status.toLowerCase() === type && shippingType === shippingtype
  )

  const { permission } = useUserPermissions({
    resources: statusGroup?.permission ? [statusGroup?.permission] : [],
  })

  return {
    canSelectMultiple: !!statusGroup && permission[statusGroup.permission],
    statusGroup,
    typeStatus: type,
  }
}

export default useConditionalsGroupOrder
